<template>
  <div>
    <!-- <p class="c-inner-title">用户标签设置</p> -->
    <div class="auto">
      <page-title title="用户标签设置" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="addHandle" class="el-icon-plus" size="small"> 添加任务</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="tag_id" label="标签">
              <template slot-scope="scope">
                <el-tag v-for="(tag, index) in scope.row.tag_id" :key="index" class="m-tb-5 m-r-5">
                  {{getName(tag)}}
                </el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="estimate_count" label="人群包总人数"></el-table-column> -->
            <el-table-column prop="count" label="成功人数"></el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column width="80" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="editHandle(scope.row)"
                  type="primary"
                  size="small">
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加任务" :modal-append-to-body="false" :visible.sync="dialogVisible" width="1200px" class="phone-d" @close="handleExit">
      <el-form ref="formTable" :rules="rules" :model="form" label-width="100px" size="small" v-loading="dialogLoading">
        <el-form-item label="名称:" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="人群包：" prop="package_id" class="custom-transfer">
          <el-transfer
            filterable
            :titles="['可选项', '已选项']"
            filter-placeholder="请输入关键字搜索"
            v-model="form.package_id"
            :data="packageList">
          </el-transfer>
        </el-form-item>
        <el-form-item label="标签" prop="tag_ids">
          <TagChooser v-model="form.tag_ids" :tags="tagList"></TagChooser>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="查看任务" :modal-append-to-body="false" :visible.sync="editVisible" width="800px" class="phone-d" @close="handleExit">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="名称" prop="name">
          {{form.name}}
        </el-form-item>
        <el-form-item label="人群包" prop="package_id">
          <ul v-if="form.package_id.length && packageList.length">
            <li v-for="(item, index) in form.package_id" :key="index" v-if="packageList.find(item2 => {return item2.key === item})">{{packageList.find(item2 => {return item2.key === item})['label']}}</li>
          </ul>
        </el-form-item>
        <el-form-item label="标签">
          <el-tag v-for="(tag, index) in form.tag_ids" :key="index" class="m-lb-5 m-r-5">
            {{getName(tag)}}
          </el-tag>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Mp } from '@/model'
export default {
  data () {
    return {
      loading: true,
      editVisible: false,
      dialogLoading: false,
      search: '',
      tableData: [],
      form: {
        name: '',
        package_id: [],
        tag_ids: []
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        tag_ids: [
          { required: true, message: '请选择标签', trigger: 'blur' }
        ],
        package_id: [
          { type: 'array', required: true, message: '请选择人群包', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      resetStatus: 1,
      tagList: [],
      filter: {
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      packageList: []
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    },
    'form.package_id': function (newval, oldval) {
      if (newval.length > 5) {
        this.$message.error('最多只能选5个人群包!')
        this.form.package_id = oldval
      }
    }
  },
  methods: {
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/custom/user_tag', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getTemplateList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    getName (id) {
      var name = ''
      this.tagList.map(item => {
        item.tag_list.map(item2 => {
          if (item2.id === id) {
            name = item2.name
          }
        })
      })
      return name
    },
    addHandle () {
      this.dialogVisible = true
    },
    editHandle (row) {
      this.editVisible = true
      this.form.name = row.name
      this.form.package_id = JSON.parse(row.package_id)
      this.form.tag_ids = row.tag_id
    },
    async deleteHandle (id) {
      this.$confirm('确定要删除吗？').then(result => {
        (async () => {
          let result = await Mp.Custom.delUserTagTask({'id': id})
          if (result && !result['err_code']) {
            this.getTemplateList()
          } else {
            this.$message.error(result['err_msg'])
          }
        })()
      }).catch(result => {
        console.log(result)
      })
    },
    handleExit () {
      this.dialogVisible = false
      this.editVisible = false
      this.form = {
        name: '',
        package_id: [],
        tag_ids: []
      }
    },
    handleSubmit () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.handleSubmitFn()
        } else {
          return false
        }
      })
    },
    async handleSubmitFn () {
      this.dialogLoading = true
      let res = await Mp.Custom.saveUserTagTask({
        name: this.form.name,
        package_id: this.form.package_id,
        tag_id: this.form.tag_ids
      })
      if (!res.err_code) {
        this.$message.success('添加成功！')
        this.dialogVisible = false
        this.resetFilter()
        this.getTemplateList()
      } else {
        this.$message.error(res.err_msg)
      }
      this.dialogLoading = false
    },
    async getTemplateList () {
      this.loading = true
      let res = await Mp.Custom.getUserTagTask(this.filter)
      this.tableData = res.data.list
      this.total = res.data.total
      this.loading = false
    },
    async getTagList () {
      let result = await Mp.Custom.getTagList()
      this.tagList = result['data']
    },
    async getFilterPackageList () {
      let res = await Mp.System.getFilterPackageList()
      if (!res['err_code']) {
        let options = []
        res['data'].map(item => {
          options.push({
            label: item.name + '（' + item.total + '人）',
            key: item.id
          })
        })
        this.packageList = options
      }
    }
  },
  created () {
    this.queryToFilter()
    this.getTagList()
    this.getFilterPackageList()
  }
}
</script>

<style scoped>
</style>
